module.exports = __webpack_public_path__ + "img/boarded.4fe63628.png";